import { ScholarshipTypeDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadScholarshipType = createAction(
  '[ScholarshipType] Load ScholarshipType'
);

export const loadScholarshipTypeSuccess = createAction(
  '[ScholarshipType] Load ScholarshipType Success',
  props<{ scholarshipType: ScholarshipTypeDto[] }>()
);

export const loadScholarshipTypeFailure = createAction(
  '[ScholarshipType] Load ScholarshipType Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addScholarshipType = createAction(
  '[ScholarshipType] Add ScholarshipType',
  props<{ newScholarshipType: ScholarshipTypeDto[] }>()
);

export const addScholarshipTypeSuccess = createAction(
  '[ScholarshipType] Add ScholarshipType Success',
  props<{ newScholarshipType: ScholarshipTypeDto[] }>()
);

export const addScholarshipTypeFailure = createAction(
  '[ScholarshipType] Add ScholarshipType Failure',
  props<{ error: any }>()
);

/**
 * Update ScholarshipType Collection Actions
 */
export const updateScholarshipType = createAction(
  '[ScholarshipType] Update ScholarshipType',
  props<{ updateScholarshipType: ScholarshipTypeDto[] }>()
);

export const updateScholarshipTypeSuccess = createAction(
  '[ScholarshipType] Update ScholarshipType Success',
  props<{ updateScholarshipType: ScholarshipTypeDto[] }>()
);

export const updateScholarshipTypeFailure = createAction(
  '[ScholarshipType] Update ScholarshipType Failure',
  props<{ error: any }>()
);

/**
 * Remove ScholarshipType Collection Actions
 */
export const removeScholarshipType = createAction(
  '[ScholarshipType] Remove ScholarshipType',
  props<{ ids: string[] }>()
);

export const removeScholarshipTypeSuccess = createAction(
  '[ScholarshipType] Remove ScholarshipType Success',
  props<{ ids: string[] }>()
);

export const removeScholarshipTypeFailure = createAction(
  '[ScholarshipType] Remove ScholarshipType Failure',
  props<{ error: any }>()
);
